import Breadcrumb from "../../components/Breadcrumbs/Breadcrumb"
import ExamQuestionAddCard from "../../components/Exams/ExamQuestionAddCard"
import ExamProgressStepper from '../../components/Exams/ExamProgressStepper'

const ExamQuestionAdd = () => {
    return (
        <>
            <Breadcrumb pageName="Add Exam" />
            <div className="grid grid-cols-10 gap-4">
                <div className="col-span-10">
                    <ExamProgressStepper current={4} />
                </div>
                <ExamQuestionAddCard />
            </div>
        </>
    )
}

export default ExamQuestionAdd